<main>
  <section>
    <app-settings-logger
      data-cy="app-settings-logger"
      [data]="data"
      [reloadDevice$]="reloadDevice$"
      (valueSelected)="onLoggerSelected()"
    >
    </app-settings-logger>
  </section>
  @if (showDevices()) {
    <section>
      <app-settings-device
        [data]="data"
        [reloadDevice$]="reloadDevice$"
        [reloadDeviceValues$]="reloadDeviceValues$"
      ></app-settings-device>
    </section>
  }

  @if (showDeviceValues()) {
    <section>
      <app-settings-value-data
        [data]="data"
        [reloadDeviceValues$]="reloadDeviceValues$"
        (valueSelected)="valueDisplaySelected()"
      ></app-settings-value-data>
    </section>
  }

  @if (data && canUseConsumption() && showConsumption) {
    <section class="consumption">
      <app-emu-list-input
        [(value)]="data['consumption']"
        (optionSelected)="valueDisplaySelected()"
        [name]="'DASHBOARD.VALUE_CALC_MODE'"
        [valueFnc]="consumptionOptionsValueFn.bind(this)"
        [clearButtonHidden]="true"
        [filteredOptions$]="consumptionOptions"
        [className]="'dashboard-settings '"
      >
        <ng-template let-item
          ><p>{{ item.name | translate }}</p></ng-template
        >
      </app-emu-list-input>
    </section>
  }
</main>
